<template>
  <div class="wp-block-group section-title">
    <div class="wp-block-group__inner-container">
      <h2>{{title}}</h2>
      <hr class="wp-block-separator" v-if="displayHR">
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
<script>
export default {
  name: "KaaliTitle",
  components: {
  },
  props: {
    title: String,
    displayHR: Boolean
  },
  data() {
    return {

    }
  },
  computed: {
  }
};
</script>
